import { JobRelatedInfoResponse } from '@doda/api-client/aspida/@types';
import { useState } from 'react';
import { getRelationInfoList } from '@doda/common/src/services/relationInfoListAPI';

/** 最初の取得では15件まで取得することができる */
const INITIAL_FETCH_COUNT = 15;
const COUNT_PER_PAGINATE = 5;

/**
 * 表示する関連情報のState管理をするカスタムフック
 * @param initialRelationInfoList 初期状態の関連情報リスト
 * @param jid 企業ID
 * @param corporateClientId 法人顧客ID
 * @param toggle アコーディオンの状態変更
 */
export const useRelationInformationList = (
  initialRelationInfoList: JobRelatedInfoResponse[],
  jid: string,
  corporateClientId: string,
  toggle: () => void
) => {
  const initialLength = initialRelationInfoList.length;
  const [relationInfoList, setRelationInfoList] = useState(
    initialRelationInfoList
  );
  const [isFetchedAllInfoList, setIsFetchedAllInfoList] = useState(
    initialLength < INITIAL_FETCH_COUNT
  );

  /** 求人を5件ずつ追加で読み込み */
  const fetchRelationInfoListPaginate = async () => {
    const { metaData, results } = await getRelationInfoList({
      jid,
      corporateClientId,
      params: {
        limit: COUNT_PER_PAGINATE,
        offset: relationInfoList.length,
      },
    });
    if (!metaData || !results) return;
    setRelationInfoList((prevRelationInfoList) => [
      ...prevRelationInfoList,
      ...results,
    ]);
    const { totalCount = 0, resultCount = 0 } = metaData;

    // すべて表示し終えたらフラグを立てる
    if (totalCount === relationInfoList.length + resultCount) {
      setIsFetchedAllInfoList(true);
      toggle();
    }
  };

  return {
    relationInfoList,
    isFetchedAllInfoList,
    fetchRelationInfoListPaginate,
  };
};
